import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import linkedin from "./assets/Linkedin-logo.png";
import qpowered from "./assets/qpowered.png";
import twitter from "./assets/Twitter-logo.png";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="h-8 flex items-center justify-end gap-2">
      <span className="text-xs ml-2 mr-auto justify-self-start">
        © {new Date().getFullYear()} quantilia.com
      </span>

      <Link to="/privacy" className="text-xs text-blue-400" target="_blank">
        {t("footer.privacy")}
      </Link>

      <Link to="/cookies" className="text-xs text-blue-400" target="_blank">
        {t("footer.cookies")}
      </Link>

      <span className="text-xs text-blue-400 cursor-pointer">
        {t("footer.followUs")}
      </span>

      <a
        className="justify-self-end"
        target="_blank"
        rel="noopener noreferrer"
        href="https://twitter.com/quantilia_web"
        aria-label={t("footer.twitter")}
      >
        <img
          src={twitter}
          className="logo"
          alt={t("footer.twitterAlt")}
          width="13px"
          height="13px"
        />
      </a>

      <a
        className="justify-self-end"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/company/quantilia/"
        aria-label={t("footer.linkedin")}
      >
        <img
          src={linkedin}
          alt={t("footer.linkedinAlt")}
          width="13px"
          height="13px"
        />
      </a>

      <img
        className="justify-self-end"
        src={qpowered}
        alt={t("footer.qpoweredAlt")}
        width="90px"
        height="40px"
      />
    </div>
  );
};

export default Footer;
